module.exports = __webpack_public_path__ + "img/tile-01.28e66159.png";